export default "__VITE_ASSET__BMFPDGfK__"